import { render, staticRenderFns } from "./NewsStyleOne.vue?vue&type=template&id=216056b2&scoped=true&"
import script from "./NewsStyleOne.vue?vue&type=script&lang=ts&"
export * from "./NewsStyleOne.vue?vue&type=script&lang=ts&"
import style0 from "./NewsStyleOne.vue?vue&type=style&index=0&id=216056b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216056b2",
  null
  
)

export default component.exports